<template>
  <div class="wrapper">
    <div class="Rtable Rtable--5cols Rtable--collapse">
        <div class="Rtable-row Rtable-row--head">
          <div class="Rtable-cell name-cell column-heading">nazwa</div>
          <div class="Rtable-cell description-cell column-heading">opis</div>
          <div class="Rtable-cell price-cell column-heading">cena</div>
          <div class="Rtable-cell action-cell column-heading"></div>
        </div>

        <div class="Rtable-row" v-for="option in options" :class="{selected: value==option.id}">
          <div class="Rtable-cell name-cell">
            <div class="Rtable-cell--content">{{option.name}}</div>
          </div>
          <div class="Rtable-cell description-cell">
            <div class="Rtable-cell--content">{{option.description}}</div>
          </div>
          <div class="Rtable-cell price-cell">
            <div class="Rtable-cell--content">{{option.price}} zł</div>
          </div>
          <div class="Rtable-cell action-cell">
            <div class="Rtable-cell--content">
              <v-btn block color="primary" @click="$emit('input', option.id)">Wybierz</v-btn>
            </div>
          </div>
        </div>
    </div>
    <div v-if="hasErrors('package')" class="error--text text-xs-center">
        Musisz wybrać pakiet.
    </div>
  </div>
</template>
<script>
export default {
  props: {
    options: Array,
    value: Number,
    formErrors: Object
  },
  methods: {
    hasErrors (name) {
      return this.formErrors[name] !== undefined && this.formErrors[name].length > 0
    },
    getErrors (name) {
      return this.formErrors[name] || []
    }
  }
}
</script>
<style lang="scss">
@import '../scss/variables';
.wrapper {
  width: 100%;
  max-width: 1000px;
  margin: 1em auto;
  padding: 1em;
}


/* Table column sizing
================================== */
.name-cell  { width: 25%; }
.description-cell  { width: 55%; }
.price-cell  { width: 15%; }
.action-cell  { width: 15%; }

/* Apply styles
================================== */
.Rtable {
  font-size: 16px;
  display: flex;
  flex-wrap: wrap;
  margin: 0 0 3em 0;
  padding: 0;

  .Rtable-row {
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
    display: flex;
    border-bottom: 1px solid rgba(0,0,0,0.12);
    &:not(.Rtable-row--head):not(.selected):hover {
      background: #eee;
    }
    &.selected {
      background: theme-color('tertiary');
      color: white;
    }

    .Rtable-cell {
      box-sizing: border-box;
      flex-grow: 1;
      padding: 0.8em 1.2em;
      overflow: hidden; // Or flex might break
      list-style: none;

      &.column-heading {
        padding: 1em;
      }

      .Rtable-cell--heading {
        display: none;
      }

      .Rtable-cell--content {
        white-space: pre-wrap;
      }
    }

    .name-cell {
      font-weight: 700;
    }
    .price-cell {
      font-style: italic;
    }

  }
  .Rtable-row--head {
    font-size: 13px;
	  color: theme-color("primary");
  }
}

/* Responsive
==================================== */
@media all and (max-width: 960px) {
  .is-striped {
    background-color: white;
  }

  .Rtable--collapse  {
    display: block;
    width: 100%;
    padding: 1em;
    box-shadow: none;

    .Rtable-row {
      box-sizing: border-box;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 2em;
      margin-left: auto;
      margin-right: auto;
      max-width: 500px;

      border-radius: 4px;
	    box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);

      .Rtable-cell {
        width: 100% !important;
        display: flex;
        align-items: center;


        .Rtable-cell--content {
          text-align: center;
          flex: 1;
          padding-left: 1em;
        }
      }
    }
    .name-cell {
      font-weight: 700;
      font-size: 18px;
    }

    .price-cell {
      font-weight: 700;
    }

    .Rtable-row--head {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/runners/PackageSelection.vue